import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Moment from 'react-moment';
import moment from 'moment';
import { connect } from 'react-redux';
import { deleteEducation } from '../../actions/profile';

const Education = ({ education, deleteEducation }) => {
  const educations = education.map((edu) => (
    <div className="credential" key={edu._id}>
      <div className="card-body p-1 m-3 rounded-lg shadow-sm">
        <h6 className="d-inline ml-1">{edu.school}</h6>
        <a
          href="#!"
          onClick={() => deleteEducation(edu._id)}
          className="text-secondary float-right delete"
        >
          <i className="fas fa-trash-alt"></i>
        </a>
        <span className="text-muted location"> &#8226; {edu.location} </span>

        <p className="ml-2 degree">
          {edu.degree} degree
          {edu.fieldofstudy && <span>, {edu.fieldofstudy}</span>}
        </p>

        <p className="mb-0 ml-2 text-muted years">
          <Moment format="YYYY">{moment.utc(edu.from)}</Moment> -{' '}
          {edu.to === null ? (
            ' Present'
          ) : (
            <Moment format="YYYY">{moment.utc(edu.to)}</Moment>
          )}{' '}
        </p>
      </div>
    </div>
  ));

  return (
    <Fragment>
      <div className="card rounded-0 my-3 shadow-sm">
        <div className="edu shadow-sm card-body pb-3">
          <div className="mb-1">
            <h5 className="m-0 d-inline">Education</h5>
            <span className="text-muted"> &#8226; College and University</span>
          </div>

          <Link to="add-education" className="add-stuff">
            <i className="fas fa-plus-circle"></i> Add education
          </Link>
        </div>

        <div className="credentials">{educations}</div>
      </div>
    </Fragment>
  );
};

Education.propTypes = {
  education: PropTypes.array.isRequired,
  deleteEducation: PropTypes.func.isRequired
};

export default connect(null, { deleteEducation })(Education);
